import { Grid } from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import Slider from "react-slick";
import { AllowedFileExtensions, SliderSettings, TotalCostSEKMax } from "../../Constant";
import { formatDate, formatDepartureDate, formatTime } from "../../Utils";
import ClaimApiService from "../../adapters/xhr/ClaimApiService";
import TrainStationApiService from "../../adapters/xhr/TrainStationApiService";
import MyContext from "../../contexts/MyContext";
import Logo from "../../static/Malartag_Logotyp_Rod_RGB.png";
import Logosvg from "../../static/malartag_favicon_blue.svg";
import Logopng from "../../static/malartag_favicon_blue_png.png";
import "./TrainPublicPage.scss";
import { Slide1 } from "./slides/Slide1";
import { Slide2 } from "./slides/Slide2";
import { Slide3 } from "./slides/Slide3";
import { Slide4 } from "./slides/Slide4";
import { Slide5 } from "./slides/Slide5";
import { Slide6 } from "./slides/Slide6";

export const TrainPublicPage = (props) => {
  let sliderRef = React.createRef();
  const myContext = useContext(MyContext);

  const fetchTrainStations = useCallback(async () => {
    let response = await TrainStationApiService.getAll();
    if (response.isSuccess) {
      myContext.changeTrainStations(response.data);
    }
  }, []);

  useEffect(() => {
    document.title = "Mälardalstrafik - EVF";
    // append link tag to document head
    document.head.appendChild(Object.assign(document.createElement("link"), { rel: "icon", type: "image/png", href: Logopng }));
    document.head.appendChild(Object.assign(document.createElement("link"), { rel: "icon", type: "image/svg+xml", href: Logosvg }));
  }, []);

  const getTotalCostMax = useCallback(async () => {
    let response = await ClaimApiService.getTotalCostMax();
    if (response.isSuccess && response.data) myContext.changeTotalCostSEKMax(response.data);
    else myContext.changeTotalCostSEKMax(TotalCostSEKMax);
  }, []);

  const getAllowedFileExtension = useCallback(async () => {
    let response = await ClaimApiService.getAllowedFileExtension();
    if (response.isSuccess && response.data) myContext.changeAllowFileUploadExtension(response.data);
    else myContext.changeAllowFileUploadExtension(AllowedFileExtensions.map((item) => item.key));
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  useEffect(() => {
    getTotalCostMax();
    getAllowedFileExtension();
    if (!myContext.trainStations || myContext.trainStations.length === 0) fetchTrainStations();
  }, []);

  const fetchDepartureTimeList = async () => {
    let response = await TrainStationApiService.getDepartureTimeList(myContext.departureStation.code, myContext.arrivalStation.code, null, formatDate(myContext.departureDate));
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  const getDistance = async () => {
    let response = await TrainStationApiService.getDistance(myContext.departureStation.code, myContext.arrivalStation.code, formatDepartureDate(myContext.departureDate, myContext.departureTime).toISOString());
    if (response?.isSuccess) {
      myContext.changeDistance(response.data);
    }
  };

  useEffect(() => {
    if (myContext.departureDate && myContext.departureStation && myContext.arrivalStation && !myContext.departureTime) {
      fetchDepartureTimeList();
      myContext.changeDepartureTime(null);
    }
  }, [myContext.departureDate, myContext.departureStation, myContext.arrivalStation]);

  useEffect(() => {
    if (myContext.departureDate && myContext.departureTime && myContext.departureStation && myContext.arrivalStation) {
      getDistance();
    }
  }, [myContext.departureDate, myContext.departureTime, myContext.departureStation, myContext.arrivalStation]);

  const setActiveSlide = (index) => {
    myContext.changeActiveSlide(index);
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="container custom padding top-2 bottom-2 left-0 right-0" justifyContent="center">
          <Grid item>
            <div hidden={context.activeSlide !== 0}>
              <img src={Logo} className="logo" title="Logo" alt="Logo" style={{ width: "10rem" }} />
            </div>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => setActiveSlide(next)}>
              <Slide1 />
              <Slide2 />
              <Slide3 />
              <Slide4 />
              <Slide5 />
              <Slide6 />
            </Slider>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
